import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, InfoIcon } from 'lucide-react';
import { alert } from '../data/homepage';
const ease = [0.23, 1, 0.32, 1] as const;
export function AlertBar() {
  const [expanded, setExpanded] = useState(false);
  return <div className="w-full bg-ville-lime text-ville-navy" data-id="element-56" data-mp="3tm42hl1ezf5a">
      <div className="mx-auto max-w-[1500px] px-5 lg:px-10" data-id="element-57" data-mp="3tkj6dqzgbo5b">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2.5" data-id="element-58" data-mp="l8ey2bf4y8zl">
          <InfoIcon className="h-4 w-4 shrink-0 text-ville-coral" aria-hidden="true" data-id="element-59" data-mp="p8yx5kj9rmod" />
          <p className="text-sm font-extrabold" data-id="element-60" data-mp="b9fn2m6we19f">{alert.title}</p>
          {!expanded && <p className="hidden text-sm text-ville-navy/70 sm:block" data-id="element-61" data-mp="g80p8r5pmv0i">{alert.detail}</p>}
          <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded} aria-controls="alert-details" className="ml-auto inline-flex items-center gap-1.5 rounded text-sm font-extrabold text-ville-coral underline-offset-4 transition-colors duration-150 ease-ville hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-coral" data-id="element-62" data-mp="g9txubzvvpb5">
            {expanded ? 'Masquer' : 'Détails'}
            <motion.span animate={{
            rotate: expanded ? 180 : 0
          }} transition={{
            duration: 0.2,
            ease
          }} className="inline-flex" data-id="element-63" data-mp="22sadbb6yx0h8">
              <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-64" data-mp="2bt8k218sjm3i" />
            </motion.span>
          </button>
        </div>

        <AnimatePresence initial={false} data-id="element-65" data-mp="2lkv2ahjjqlfr">
          {expanded && <motion.div id="alert-details" key="details" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          height: {
            duration: 0.28,
            ease
          },
          opacity: {
            duration: 0.18,
            ease
          }
        }} className="overflow-hidden" data-id="element-66" data-mp="2lk35x4i4kjof">
              <motion.div initial={{
            y: -6
          }} animate={{
            y: 0
          }} exit={{
            y: -6
          }} transition={{
            duration: 0.24,
            ease
          }} className="max-w-3xl border-t border-ville-navy/20 pb-4 pt-3 text-sm leading-relaxed text-ville-navy/80" data-id="element-67" data-mp="32lz7dpcx2qem">
                {alert.body.map((paragraph, index) => <p key={paragraph} className={index === 0 ? undefined : 'mt-2'} data-id="element-68" data-mp="3hdhj3ayqtys6" data-mpi={index}>
                    {paragraph}
                  </p>)}
                <p className="mt-2 text-ville-navy/60" data-id="element-69" data-mp="3qd4nm5mrrkpg">{alert.scope}</p>
              </motion.div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}